export enum DockEndpoint {
  Base = '/docks',
  Overview = '/overview',
  Enable = '/enable',
  Qr = '/qr',
}
